/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The display class of this variant.
 */
export var ActionVariant;
(function (ActionVariant) {
    ActionVariant["PRIMARY"] = "primary";
    ActionVariant["SECONDARY"] = "secondary";
    ActionVariant["TERTIARY"] = "tertiary";
})(ActionVariant || (ActionVariant = {}));
